export default __webpack_public_path__ + "static/media/medium1.8ad400af.png";